import axios from "axios";
import { AppServices, HttpHeaders } from "../Services/AppServices";

export const QuestionReorder = async (data) => {
  return axios.post(AppServices.POST_QUESTION_REORDER(), data, HttpHeaders());
}